import * as React from 'react';
import styles from './index.less';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { CollectionManagerState, ConnectState } from '@/models/connect';
import FLink from '@/components/FLink';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import fMessage from '@/components/fMessage';
import { Space } from 'antd';
import FTooltip from '@/components/FTooltip';
import FSwitch from '@/components/FSwitch';
import { FetchResourceInfoAction } from '@/models/resourceAuthPage';
import * as AHooks from 'ahooks';
// import FComponentsLib from '@freelog/components-lib';
// import fPolicyBuilder from '@/components/fPolicyBuilder';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import fPolicyOperator from '@/components/fPolicyOperator';
import { fOnOffFeedback } from '@/components/fOnOffFeedback';
import FProcessing from '@/components/FProcessing';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import FCoverImage from '@/components/FCoverImage';
import FResourceStatusBadge from '@/components/FResourceStatusBadge';
import {
  Sider_OnMount_Page_Action,
  Sider_OnUnmount_Page_Action,
  Sider_OnUpdate_Data_Action,
} from '@/models/collectionManager';
import FIcons from '@/components/FIcons';
import FSimpleBar from '@/components/FSimpleBar';
import fPolicyBuilder3 from '@/components/fPolicyBuilder3';

interface SilderProps {
  dispatch: Dispatch;
  // resourceSider: ResourceSiderModelState;
  collectionManager: CollectionManagerState;
}

function Sider({ dispatch, collectionManager }: SilderProps) {
  // const [$resourceAuthShownArray, set$resourceAuthShownArray] = AHooks.useLocalStorageState<{ [k: string]: string }>(
  //   'resourceAuthShownArray',
  //   {
  //     defaultValue: {},
  //   },
  // );

  const [$processing, set$processing, get$processing] = FUtil.Hook.useGetState<string>('');

  AHooks.useMount(() => {
    dispatch<Sider_OnMount_Page_Action>({
      type: 'collectionManager/sider_onMount_Page',
      payload: {
        resourceID: '',
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<Sider_OnUnmount_Page_Action>({
      type: 'collectionManager/sider_onUnmount_Page',
    });
  });

  async function changeStatus(value: boolean) {
    if (value) {
      // set$processing(FI18n.i18nNext.tAuto('set_resource_available_for_auth_msg_processing'));
      const onlineSuccess = await resourceOnline(collectionManager.sider_resourceID);
      if (onlineSuccess) {
        setTimeout(() => {
          set$processing('');
          fOnOffFeedback({
            state: 'on',
            message: FI18n.i18nNext.t('set_resource_available_for_auth_msg_done'),
          });
        }, 1000);

        dispatch<Sider_OnUpdate_Data_Action>({
          type: 'collectionManager/sider_onUpdate_Data',
        });

        dispatch<FetchResourceInfoAction>({
          type: 'resourceAuthPage/fetchResourceInfo',
        });
      } else {
        set$processing('');
      }
    } else {
      // 下架
      const bool: boolean = await fPromiseModalConfirm({
        title: FI18n.i18nNext.t('remove_resource_from_auth_confirmation_title'),
        description: FI18n.i18nNext.t('confirm_msg_remove_resource_from_auth'),
        okText: FI18n.i18nNext.t('remove_resource_from_auth_btn_remve'),
        promptKey_localStorage:
          FI18n.i18nNext.t('remove_resource_from_auth_confirmation_title') || '',
      });

      if (bool) {
        const data = { status: 4 };
        operateResource(data);
      }
    }
  }

  /** 资源上下架 */
  async function operateResource(data: any) {
    set$processing(FI18n.i18nNext.tAuto('remove_resource_from_auth_msg_processing'));
    const { ret, errCode, msg } = await FServiceAPI.Resource.update({
      resourceId: collectionManager.sider_resourceID,
      status: data.status,
    });

    if (ret !== 0 && errCode !== 0) {
      fMessage(msg, 'error');
      set$processing('');
      return;
    }
    setTimeout(() => {
      set$processing('');
      fOnOffFeedback({
        state: 'off',
        message: FI18n.i18nNext.t('remove_resource_from_auth_msg_done'),
      });
    }, 1000);
    dispatch<Sider_OnUpdate_Data_Action>({
      type: 'collectionManager/sider_onUpdate_Data',
    });

    dispatch<FetchResourceInfoAction>({
      type: 'resourceAuthPage/fetchResourceInfo',
    });
  }

  if (collectionManager.sider_state === 'loading') {
    return null;
  }

  return (
    <FSimpleBar height={'calc(100vh - 70px)'}>
      <div className={styles.Sider}>
        <div style={{ height: 30 }} />
        <div className={styles.switcher}>
          <div className={styles['switcher-label']}>
            {FI18n.i18nNext.tAuto('switch_set_resource_avaliable')}
          </div>
          <FSwitch
            // onClick={changeStatus}
            onChange={(checked) => {
              changeStatus(checked);
            }}
            checked={collectionManager.sider_resourceState === 'online'}
            // loading={loading}
            loading={$processing !== ''}
          />
        </div>
        <div style={{ height: 30 }} />
        <div className={styles.header}>
          <div
            style={{
              display: 'inline-block',
              width: 'fit-content',
              height: 'fit-content',
              position: 'relative',
            }}
          >
            <div className={styles.Cover}>
              <FCoverImage src={collectionManager.sider_resourceCover || ''} width={200} />
              <div className={styles.Status}>
                <FResourceStatusBadge status={collectionManager.sider_resourceState as 'online'} />
                {collectionManager.sider_isChoice && (
                  <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                    <img src={img_choiceLabel} alt={''} style={{ width: 24, height: 24 }} />
                  </FTooltip>
                )}
              </div>
            </div>
          </div>
          <div style={{ height: 15 }} />
          <FTooltip title={FI18n.i18nNext.tAuto('editresource_viewresource')} placement={'top'}>
            <FLink
              to={FUtil.LinkTo.collectionDetails({
                collectionID: collectionManager.sider_resourceID,
              })}
              target={'_blank'}
              className={styles.resourceName}
            >
              {collectionManager.sider_resourceTitle ||
                collectionManager.sider_resourceName.split('/')[1]}
            </FLink>
          </FTooltip>
          <div style={{ height: 10 }} />
          <label className={styles.label}>{collectionManager.sider_resourceType.join(' / ')}</label>
        </div>
        <div style={{ height: 35 }} />
        <div className={styles.radios}>
          <FLink
            className={[
              collectionManager.sider_showPage === 'versionInfo' ? styles.activatedRadio : '',
              styles.radio,
            ].join(' ')}
            to={FUtil.LinkTo.collectionVersionInfo({
              collectionID: collectionManager.sider_resourceID,
              // version: collectionManager.sider_resourceVersions[collectionManager.sider_resourceVersions.length - 1] || '',
            })}
          >
            {FI18n.i18nNext.tAuto('edit_collection_tab_itemmgnt')}
          </FLink>
          <FLink
            className={[
              collectionManager.sider_showPage === 'info' ? styles.activatedRadio : '',
              styles.radio,
            ].join(' ')}
            to={FUtil.LinkTo.collectionInfo({
              collectionID: collectionManager.sider_resourceID,
            })}
          >
            {FI18n.i18nNext.tAuto('edit_collection_tab_info')}
          </FLink>
          <FLink
            className={[
              collectionManager.sider_showPage === 'policy' ? styles.activatedRadio : '',
              styles.radio,
            ].join(' ')}
            to={FUtil.LinkTo.collectionPolicy({
              collectionID: collectionManager.sider_resourceID,
            })}
          >
            <span>{FI18n.i18nNext.tAuto('edit_collection_tab_authplan')}</span>
            {/*{resourceSider.policies.length === 0 && !$resourceAuthShownArray?[resourceSider.resourceID] && (*/}
            {/*  <div className={styles.redDot} />*/}
            {/*)}*/}
          </FLink>
          <FLink
            className={[
              collectionManager.sider_showPage === 'contract' ? styles.activatedRadio : '',
              styles.radio,
            ].join(' ')}
            to={FUtil.LinkTo.collectionContract({
              collectionID: collectionManager.sider_resourceID,
            })}
          >
            {FI18n.i18nNext.tAuto('edit_collection_tab_contracts')}
          </FLink>
          <FLink
            className={[
              collectionManager.sider_showPage === 'dependency' ? styles.activatedRadio : '',
              styles.radio,
            ].join(' ')}
            to={FUtil.LinkTo.collectionDependency({
              collectionID: collectionManager.sider_resourceID,
            })}
          >
            <Space size={10}>
              <span>{FI18n.i18nNext.tAuto('edit_collection_tab_upstreamauthmgnt')}</span>
              {collectionManager.sider_hasAuthProblem && (
                <FTooltip
                  //  title={'存在授权问题'}
                  title={FI18n.i18nNext.tAuto('alert_resource_no_auth')}
                >
                  <FIcons.FWarning style={{ fontSize: 16 }} />
                </FTooltip>
              )}
            </Space>
          </FLink>
        </div>
        <div style={{ height: 40 }} />

        <FProcessing open={$processing !== ''} message={$processing} />
      </div>
    </FSimpleBar>
  );
}

export default connect(({ resourceSider, collectionManager }: ConnectState) => ({
  // resourceSider: resourceSider,
  collectionManager: collectionManager,
}))(Sider);

export async function resourceOnline(resourceID: string): Promise<boolean> {
  const { data: data_resourceInfo }: { data: any } = await FServiceAPI.Resource.info({
    resourceIdOrName: resourceID,
    isLoadPolicyInfo: 1,
    isLoadLatestVersionInfo: 1,
    isTranslate: 1,
  });

  if (!data_resourceInfo.latestVersion) {
    fMessage(FI18n.i18nNext.tAuto('msg_release_version_first'), 'error');
    return false;
  } else if (data_resourceInfo.policies.length === 0) {
    const confirm = await fPromiseModalConfirm({
      title: FI18n.i18nNext.t('set_resource_available_for_auth_activate_auth_plan_title'),
      description: FI18n.i18nNext.t('msg_set_resource_avaliable_for_auth01'),
      okText: FI18n.i18nNext.t('set_resource_available_for_auth_btn_create_auth_plan'),
      cancelText: FI18n.i18nNext.t('btn_cancel'),
    });
    if (!confirm) {
      return false;
    }

    const policy = await fPolicyBuilder3({
      alreadyUsedTexts: (data_resourceInfo.policies as any[]).map<string>((ip) => {
        return ip.policyText;
      }),
      alreadyUsedTitles: (data_resourceInfo.policies as any[]).map((ip) => {
        return ip.policyName;
      }),
      // targetType: 'resource',
    });

    if (!policy) {
      return false;
    }

    const params: Parameters<typeof FServiceAPI.Resource.update>[0] = {
      resourceId: resourceID,
      status: 1,
      addPolicies: [
        {
          policyName: policy.title,
          policyText: window.encodeURIComponent(policy.text),
          status: 1,
        },
      ],
    };
    await FServiceAPI.Resource.update(params);
    return true;
  } else if (
    data_resourceInfo.policies.every((p: any) => {
      return p.status === 0;
    })
  ) {
    const existingUsedPolicy = await fPolicyOperator({
      titleText: FI18n.i18nNext.tAuto('set_resource_available_for_auth_activate_auth_plan_title'),
      confirmText: FI18n.i18nNext.tAuto('set_resource_available_for_auth_activate_auth_plan_btn_done'),
      tipText: FI18n.i18nNext.tAuto('msg_set_resource_avaliable_for_auth02'),
      policiesList: data_resourceInfo.policies as any,
    });

    if (!existingUsedPolicy) {
      return false;
    }

    const params: Parameters<typeof FServiceAPI.Resource.update>[0] = {
      resourceId: resourceID,
      status: 1,
      updatePolicies: existingUsedPolicy.map((p) => {
        return {
          policyId: p.policyID,
          status: p.checked ? 1 : 0, // 0:下线策略 1:上线策略
        };
      }),
    };
    await FServiceAPI.Resource.update(params);
    return true;
  }

  const params: Parameters<typeof FServiceAPI.Resource.update>[0] = {
    resourceId: resourceID,
    status: 1,
  };
  await FServiceAPI.Resource.update(params);

  return true;
}
